/** Cookie mirrored from sessionStorage so BFF /api-docs can verify staff login in a new tab. */
export const ADMIN_STAFF_JWT_COOKIE = 'admin-staff-jwt';

const MAX_AGE_SEC = 7 * 24 * 60 * 60;

export function syncAdminStaffTokenCookie(token) {
  if (typeof document === 'undefined') return;
  const value = String(token || '').trim();
  if (!value) {
    clearAdminStaffTokenCookie();
    return;
  }
  document.cookie = `${ADMIN_STAFF_JWT_COOKIE}=${encodeURIComponent(value)}; Path=/; SameSite=Lax; Max-Age=${MAX_AGE_SEC}`;
}

export function clearAdminStaffTokenCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${ADMIN_STAFF_JWT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}
